import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {}

export const PageNotFoundSVG: React.FC<IProps> = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      viewBox='0 0 500 500'
      {...props}
    >
      <defs>
        <linearGradient
          id='linear-gradient-404-page-not-found'
          x1={286.93}
          y1={2483.96}
          x2={291.11}
          y2={2365.54}
          gradientTransform='matrix(1 0 0 -1 -31 2886.34)'
          gradientUnits='userSpaceOnUse'
        >
          <stop
            offset={0}
            stopOpacity={0}
          />
          <stop offset={0.95} />
        </linearGradient>
        <linearGradient
          id='linear-gradient-2-404-page-not-found'
          x1={159.21}
          y1={2523.23}
          x2={155.03}
          y2={2688.34}
          gradientTransform='matrix(1 0 0 -1 -31 2886.34)'
          gradientUnits='userSpaceOnUse'
        >
          <stop
            offset={0}
            stopOpacity={0}
          />
          <stop offset={0.99} />
        </linearGradient>
        <linearGradient
          id='linear-gradient-3-404-page-not-found'
          x1={429.36}
          y1={2545.99}
          x2={426.58}
          y2={2649.56}
          xlinkHref='#linear-gradient-404-page-not-found'
        />
        <linearGradient
          id='linear-gradient-4-404-page-not-found'
          x1={284.35}
          y1={2513.45}
          x2={290.85}
          y2={2738.24}
          xlinkHref='#linear-gradient-2-404-page-not-found'
        />
      </defs>
      <path
        id='background_404-page-not-found'
        className='targetColor'
        d='M168.96 326.68c29.67 13.04 63.23 12.84 95.64 12.41 17-.22 34.59-.56 50.07-7.6 21.52-9.8 35.5-30.83 54.38-45.07 21.68-16.37 49.43-23.43 70.45-40.63 38.88-31.8 44.62-89.1 12.83-127.98-3.19-3.9-6.7-7.53-10.49-10.85-11.12-9.73-24.39-16.6-37.55-23.36l-66.07-34c-15.48-7.96-31.36-16.05-48.64-18.22-14.58-1.82-29.33.7-43.57 3.96-40.6 9.18-80.89 25.01-110.68 53.97-25.62 24.96-42.35 58.49-70.39 80.72-7.17 5.67-15.12 10.67-20.34 18.16-18.8 26.99.24 61.46 24.66 75.3 33.82 19.14 64.25 47.62 99.7 63.19z'
        style={{
          isolation: 'isolate'
        }}
        fill='currentColor'
        opacity={0.18}
        strokeWidth={0}
      />
      <g id='_404_404-page-not-found'>
        <ellipse
          cx={257.3}
          cy={441.28}
          rx={226.23}
          ry={27.95}
          fill='currentColor'
          strokeWidth={0}
        />
        <ellipse
          cx={257.3}
          cy={441.28}
          rx={226.23}
          ry={27.95}
          strokeWidth={0}
          fill='url(#linear-gradient)'
        />
        <path
          fill="#eea886"
          d='M133.37 168.23a37.872 37.872 0 00-28.95-5.74c-1.82.28-3.53 1.02-4.99 2.14-3.4 2.87-2.87 8.21-3.77 12.6-1.1 5.41-4.73 10.04-6.04 15.38-.76 4.02-.8 8.14-.13 12.17 1.91 15.9 5.72 31.52 11.35 46.51L85.06 459.2s16.14 2.61 48.88 5.22l3.47-197.99-4.03-98.19z'
        />
        <path
          fill='url(#linear-gradient-2-404-page-not-found)'
          strokeWidth={0}
          d='M115.42 289.48L136.32 374.02 136.32 252.09 127.03 224.46 115.42 289.48z'
        />
        <path
          fill="#eea886"
          d='M388.78 170.01c8.5-5.71 18.94-7.73 28.95-5.62 1.82.29 3.54 1.02 5.01 2.14 3.39 2.87 2.87 8.21 3.76 12.61 1.12 5.41 4.75 10.04 6.05 15.38.76 4.01.8 8.13.11 12.15-1.9 15.9-5.7 31.52-11.33 46.51l15.71 205.01s-17.58 2.96-48.98 5.93l-3.37-195.81 4.09-98.29z'
        />
        <path
          fill='url(#linear-gradient-3-404-page-not-found)'
          strokeWidth={0}
          d='M409.41 283.44L402 321.53 386.2 355.9 384.81 281.12 409.41 283.44z'
        />
        <rect
          x={106.6}
          y={100.22}
          width={303.75}
          height={191.35}
          rx={12.01}
          ry={12.01}
          fill="currentColor"
          strokeWidth={0}
        />
        <rect
          x={106.6}
          y={100.22}
          width={303.75}
          height={191.35}
          rx={12.01}
          ry={12.01}
          fill='url(#linear-gradient-4-404-page-not-found)'
          strokeWidth={0}
        />
        <rect
          x={106.6}
          y={92.55}
          width={303.75}
          height={191.35}
          rx={12.01}
          ry={12.01}
          fill="currentColor"
          strokeWidth={0}
        />
        <path
          strokeWidth={0}
          fill='#fff'
          d='M133.5 172.32q4.84-5.37 10.3-11.79l23.29-27.26c3.66-4 7.02-8.27 10.04-12.77h21.99c-.62 5.91-.9 11.86-.85 17.81v34.88h3.11c3.56-.03 7.1-.32 10.62-.86v19.54c-3.49-.43-7-.65-10.52-.65h-3.21v5.37c-.1 4.42.18 8.83.85 13.2h-22.09c.6-4.45.88-8.93.85-13.41v-5.18h-30.42c-6.99 0-10.04.1-13.96.42v-19.28zm44.47-11.36c0-4.84.22-10.73.65-15.45-2.15 3-3.76 5.15-6.66 8.79l-15.71 19.1h21.68l.04-12.44zM229.75 201.73a34.009 34.009 0 01-7.83-11.91 71.211 71.211 0 01-4.19-24.58c0-11.28 2.68-22.96 6.77-29.73 6.54-10.95 17.7-16.96 31.22-16.96 10.42 0 19.54 3.54 26.08 10.04 3.43 3.37 6.1 7.43 7.83 11.91a71.3 71.3 0 014.19 24.68c0 11.28-2.68 23.08-6.76 29.84-6.44 10.73-17.72 16.74-31.35 16.74-10.52-.06-19.41-3.5-25.97-10.04zm10.05-37.3c0 19.21 5.47 29.08 16.1 29.08s15.88-9.66 15.88-28.69c-.06-18.47-5.68-28.15-16.05-28.15s-15.98 10.23-15.98 27.72l.06.04zM299.4 172.32q4.84-5.37 10.3-11.79l23.3-27.26c3.64-4 6.97-8.27 9.97-12.77h22.01c-.63 5.91-.92 11.86-.86 17.81v34.88h3.11c3.56-.03 7.1-.32 10.62-.86v19.54c-3.49-.43-7-.65-10.52-.65h-3.21v5.37c-.1 4.42.19 8.83.86 13.2h-22.11c.6-4.45.89-8.93.86-13.41v-5.18h-30.37c-6.97 0-10.04.1-13.96.42v-19.28zm44.47-11.36c0-4.84.22-10.73.65-15.45-2.15 3-3.76 5.15-6.66 8.79l-15.71 19.1h21.68l.04-12.44zM134.53 241.22c1.81-.3 3.64-.44 5.47-.43 2.22-.17 4.43.48 6.2 1.84 1.29 1.18 2 2.87 1.94 4.62.09 1.74-.53 3.44-1.71 4.72a9.117 9.117 0 01-6.76 2.42c-.77.03-1.53-.04-2.28-.2v8.85h-2.87v-21.82zm2.87 10.64c.77.18 1.56.26 2.35.23 3.44 0 5.54-1.66 5.54-4.72s-2.07-4.3-5.21-4.3c-.9-.02-1.8.05-2.68.23v8.57zM152.75 256.09l-2.3 6.94h-2.87l7.49-22.08h3.41l7.53 22.08h-3.04l-2.35-6.94h-7.88zm7.18-2.22l-2.17-6.36c-.49-1.43-.82-2.75-1.15-4.03a72.48 72.48 0 01-1.1 3.99l-2.17 6.4h6.59zM185.58 262.05c-2.18.79-4.47 1.2-6.79 1.22-5.7.55-10.77-3.63-11.32-9.33-.06-.6-.06-1.21-.02-1.82 0-6.59 4.55-11.39 11.95-11.39 1.89-.05 3.76.3 5.51 1.02l-.69 2.32c-1.54-.67-3.2-1-4.88-.95-5.38 0-8.88 3.34-8.88 8.87s3.37 8.92 8.52 8.92c1.3.07 2.59-.14 3.8-.6v-6.57h-4.49v-2.3h7.27v10.6zM201.36 252.68h-8.61v7.96h9.57v2.4H189.9v-22.08h11.94v2.4h-9.05v6.97h8.61l-.03 2.35zM213.01 263.04v-22.08h3.11l7.07 11.16c1.47 2.31 2.8 4.7 3.97 7.17-.26-2.87-.33-5.62-.33-9.07v-9.24h2.7v22.08h-2.87l-7.02-11.21c-1.52-2.37-2.9-4.84-4.13-7.37h-.1c.17 2.8.23 5.45.23 9.11v9.44H213zM253.43 251.76c0 7.6-4.62 11.64-10.26 11.64s-9.93-4.52-9.93-11.21c0-7.02 4.3-11.59 10.26-11.59s9.93 4.62 9.93 11.16zm-17.13.36c0 4.72 2.55 8.95 7.04 8.95s7.07-4.16 7.07-9.18c0-4.38-2.3-8.97-7.04-8.97s-7.07 4.36-7.07 9.2zM260.5 243.38h-6.71v-2.42h16.36v2.42h-6.76v19.66h-2.87v-19.66zM279.54 240.96h11.89v2.4h-9.04v7.33h8.35v2.35h-8.35v10.04h-2.87v-22.12zM314.36 251.76c0 7.6-4.62 11.64-10.24 11.64s-9.93-4.52-9.93-11.21c0-7.02 4.3-11.59 10.24-11.59s9.93 4.62 9.93 11.16zm-17.13.36c0 4.72 2.55 8.95 7.04 8.95s7.07-4.16 7.07-9.18c0-4.38-2.3-8.97-7.04-8.97s-7.07 4.36-7.07 9.2zM320.92 240.96v13.07c0 4.95 2.2 7.04 5.15 7.04 3.27 0 5.37-2.17 5.37-7.04v-13.07h2.87v12.91c0 6.79-3.57 9.57-8.35 9.57-4.52 0-7.93-2.58-7.93-9.44v-13l2.9-.04zM339.27 263.04v-22.08h3.11l7.07 11.16c1.47 2.3 2.8 4.7 3.96 7.17h.07c-.26-2.87-.33-5.62-.33-9.07v-9.24h2.68v22.08h-2.87l-7-11.21a67.361 67.361 0 01-4.13-7.37h-.1c.16 2.8.23 5.45.23 9.11v9.44h-2.7zM360.79 241.25c2.01-.3 4.04-.46 6.07-.46 4.09 0 7.02.96 8.94 2.75 2.15 2.06 3.29 4.96 3.11 7.93.16 3.18-.98 6.29-3.17 8.61-2.07 2.07-5.48 3.19-9.77 3.19a44.9 44.9 0 01-5.18-.34v-21.68zm2.87 19.52c.95.14 1.91.2 2.87.17 6.1 0 9.4-3.41 9.4-9.37 0-5.21-2.87-8.52-8.94-8.52-1.12-.02-2.24.08-3.34.3v17.42z'
        />
        <path
          fill="#eea886"
          d='M119.47 165.72c1.23.61 2.28 1.54 3.04 2.68.63 1.35.94 2.82.9 4.3l.43 9.25c.19 1.52.01 3.07-.53 4.51a3.263 3.263 0 01-3.7 1.95c1.11 3.64.68 7.58-1.19 10.89-.46.69-.83 1.44-1.08 2.24-.12.96-.07 1.93.14 2.87.66 4.7-.74 9.45-3.83 13.04-.47.58-1.04 1.07-1.69 1.43-.85.36-1.77.56-2.7.57l-4.22.36a1.43 1.43 0 01-1.81-.92c-.04-.12-.06-.24-.07-.36a94.078 94.078 0 01-4.3-31.44c.17-5.36.81-10.7 1.92-15.95.67-3.07 1.99-7.75 5.28-9 4.25-1.49 9.73 1.45 13.4 3.56zM396.54 165.72a7.861 7.861 0 00-3.04 2.68 9.555 9.555 0 00-.9 4.3l-.43 9.25c-.19 1.52-.01 3.07.53 4.51.6 1.46 2.16 2.28 3.7 1.95-1.11 3.64-.68 7.57 1.18 10.89.47.69.84 1.44 1.09 2.24.12.96.07 1.93-.16 2.87-.64 4.7.76 9.45 3.85 13.04.47.58 1.04 1.07 1.69 1.43.85.36 1.77.56 2.7.57l4.26.42c.75.25 1.56-.16 1.81-.92.04-.12.06-.24.07-.36a94.078 94.078 0 004.3-31.44 88.12 88.12 0 00-1.94-15.95c-.66-3.07-1.43-6.92-4.69-8.16-4.29-1.56-10.34.56-14.02 2.67z'
        />
      </g>
    </svg>
  );
};
